import React from "react";
import PropTypes from "prop-types";
import { NavLink } from "reactstrap";
import CollapseSection from "../../../commons/collapse/components/collapse-section";

function SportsFilter(props) {
  const { types, filters, handleClick, tabName } = props;
  return (
    <CollapseSection
      bodyClassName="filter-collapsible-section sport-section"
      sectionName={types.find((type) => type.value === filters.sport).text}
    >
      <>
        {types.map((option) => (
          <NavLink
            href="#"
            key={`${tabName}-sport-${option.value}-${option.text}`}
            className="menu-filter filter-option"
            tabIndex="0"
            onClick={handleClick(option.value)}
          >
            <span>{option.text}</span>
          </NavLink>
        ))}
      </>
    </CollapseSection>
  );
}

SportsFilter.propTypes = {
  types: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.number,
      text: PropTypes.string
    })
  ).isRequired,
  filters: PropTypes.shape({
    sport: PropTypes.number.isRequired
  }).isRequired,
  handleClick: PropTypes.func.isRequired,
  tabName: PropTypes.string.isRequired
};

export default SportsFilter;
